module.exports = __webpack_public_path__ + "static/media/rober8.ca675423.jpg";